// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";
import { isGetEngagementContentBlocksIdResult } from "@dashboardApi/apis/engagementContentBlocksId";

export const isEngagementContentBlocksDuplicateResult = objectOf({
  info: string,
  template: isGetEngagementContentBlocksIdResult,
});
